/** @file Clock hook: Date.now() re-read on a timer so time-based views stay true between store changes. */
import { useEffect, useState } from 'react';

/** `Date.now()` at every render; a timer forces one render per `periodMs` while the component is mounted. */
export function useNow(periodMs: number): number {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => { setTick((n) => n + 1); }, periodMs);
    return () => { clearInterval(id); };
  }, [periodMs]);
  return Date.now();
}
